// Generated by CoffeeScript 2.7.0
import {
  Schema
} from 'prosemirror-model';

import nodes from './nodes.js';

import marks from './marks.js';

export default new Schema({nodes, marks});
